export const ALERT_TABLE_HEADINGS: Record<
  string,
  {
    heading?: TranslationKey;
    key: string;
    align: 'left' | 'right';
    width?: number;
  }
> = {
  scripName: {
    heading: 'SCRIP_NAME',
    key: 'scripName',
    align: 'left',
    width: 140,
  },
  alertPrice: {
    heading: 'ALERT_PRICE',
    key: 'alertPrice',
    align: 'right',
    width: 140,
  },
  status: {
    heading: 'STATUS',
    key: 'status',
    align: 'right',
    width: 80,
  },
  action: {
    key: 'action',
    align: 'left',
    width: 90,
  },
};

export const ALERT_TABLE_DATA = [
  {
    scripName: 'ABC',
    alertPrice: '100',
    status: 'Active',
    action: 'Delete',
  },
];

export type ALERT_TABLE_HEADINGS_KEYS = keyof typeof ALERT_TABLE_HEADINGS;
